var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarWeek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#7f8090",
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 19q-.425 0-.712-.288-.288-.287-.288-.712V6q0-.425.288-.713Q13.325 5 13.75 5h1.375q.425 0 .713.287.287.288.287.713v12q0 .425-.287.712-.288.288-.713.288Zm-4.875 0q-.425 0-.712-.288-.288-.287-.288-.712V6q0-.425.288-.713Q8.45 5 8.875 5h1.375q.425 0 .713.287.287.288.287.713v12q0 .425-.287.712-.288.288-.713.288ZM4 19q-.425 0-.712-.288Q3 18.425 3 18V6q0-.425.288-.713Q3.575 5 4 5h1.375q.425 0 .713.287.287.288.287.713v12q0 .425-.287.712Q5.8 19 5.375 19Zm14.625 0q-.425 0-.712-.288-.288-.287-.288-.712V6q0-.425.288-.713Q18.2 5 18.625 5H20q.425 0 .712.287Q21 5.575 21 6v12q0 .425-.288.712Q20.425 19 20 19Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWeek);
export default __webpack_public_path__ + "static/media/calendar_week.058a36c2.svg";
export { ForwardRef as ReactComponent };